"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
var asap_1 = require("rxjs/scheduler/asap");
require("rxjs/add/operator/map");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/share");
require("rxjs/add/operator/do");
require("rxjs/add/operator/scan");
require("rxjs/add/operator/startWith");
require("rxjs/add/operator/mergeScan");
require("rxjs/add/operator/publish");
require("rxjs/add/operator/catch");
require("rxjs/add/operator/mergeMap");
require("rxjs/add/operator/concat");
require("rxjs/add/observable/merge");
require("rxjs/add/observable/concat");
require("rxjs/add/observable/from");
require("rxjs/add/observable/of");
var QueryProcessor = (function () {
    function QueryProcessor() {
        this.source = new Subject_1.Subject();
        this.source.subscribe(function (event) {
            console.log('source got event', event);
        });
        this.sharedSource = this.source.share();
    }
    QueryProcessor.prototype.reduce = function (reducer, init, sourceOrFirstEvent) {
        if (sourceOrFirstEvent === void 0) { sourceOrFirstEvent = this.sharedSource; }
        var source;
        if (sourceOrFirstEvent instanceof Observable_1.Observable) {
            source = Observable_1.Observable.merge(this.sharedSource, sourceOrFirstEvent, asap_1.asap);
        }
        else {
            source = Observable_1.Observable.merge(this.sharedSource, Observable_1.Observable.of(sourceOrFirstEvent), asap_1.asap);
        }
        var acc = function (prevState, event) {
            try {
                var result = reducer(event, prevState);
                if (result instanceof Observable_1.Observable) {
                    return result;
                }
                return Observable_1.Observable.from(Promise.resolve(result), asap_1.asap)
                    .catch(function (e) {
                    console.error('error in reducer, keeping previous state', e);
                    return Observable_1.Observable.of(prevState);
                });
            }
            catch (e) {
                console.error('error in reducer, keeping previous state', e);
                return Observable_1.Observable.of(prevState);
            }
        };
        var stream = source.mergeScan(acc, init);
        return Observable_1.Observable.of(init).concat(stream, asap_1.asap);
    };
    return QueryProcessor;
}());
exports.QueryProcessor = QueryProcessor;
var QueryLayer = (function () {
    function QueryLayer(queries) {
        this.queries = queries;
    }
    QueryLayer.prototype.subcribeTo = function (bus) {
        return bus.subscribe(this.queries.source);
    };
    return QueryLayer;
}());
exports.QueryLayer = QueryLayer;
//# sourceMappingURL=query.js.map